export default __webpack_public_path__ + "static/media/RotateLeft.0760eed1.svg";